import React from "react";
import { ImageOverlay } from "../elements/headerComponents";
import { Section, Card } from "../elements/bodyComponents";
import { SectionTitle } from "../typography/typography";
import {
  ShuffleArray,
  SortArray,
  CheckVis,
  ScrollTo
} from "../helpers/helpers";
import { Button } from "../elements/buttons";
import throttle from "es6y-throttle/dist/throttle";
import {
  BuildImagePath,
  ScrollToPosition,
  ShowPage,
  HidePage
} from "../helpers/helpers";

//style
import "../css/recipes.css";

//data
import { Recipes } from "../json/recipes";

/*
    Homepage
*/
export class AllRecipes extends React.Component {
  constructor(props) {
    super(props);

    this.getRecipes = this.getRecipes.bind(this);

    this.state = {
      recipeGroups: this.getRecipes()
    };
  }

  /*
        Get All Recipes
        Sort by category
    */
  getRecipes() {
    let recipes = SortArray(Recipes, "category");

    console.log(recipes);
    return this.buildRecipeGroups(recipes);
  }

  /*
        Build Recipe Groups
    */
  buildRecipeGroups(recipeGroups) {
    /*return recipeGroups.map( ( r ) => (
            <RecipeGroup />
        ) );*/
    let groups = [];
    for (let g in recipeGroups) {
      groups.push(<RecipeGroup key={g} title={g} recipes={recipeGroups[g]} />);
    }
    return groups;
  }

  componentDidMount() {
    ShowPage(false);

    //check if URL query exists and scroll to that item
    if (typeof URLSearchParams !== "undefined") {
      const urlParams = new URLSearchParams(window.location.search);

      //scroll to category
      if (urlParams.has("category")) {
        let category = urlParams.get("category");
        console.log("category is", category);

        ScrollTo(document.getElementById(category));
      } else {
        //scroll page to top
        ScrollToPosition(0);
      }
    }

    document
      .querySelector(".globalNav")
      .setAttribute("data-activepage", "recipes");
  }

  componentWillUnmount() {
    HidePage();
  }

  render() {
    const imageSizeArray = [
      {
        w: 480,
        name: "small"
      },
      {
        w: 4000,
        name: "large"
      }
    ];

    return (
      <div className="layout-allRecipes usingMasterCard">
        <header className="pageHeader">
          <ImageOverlay classes="introOverlay text-align-center">
            <h1 className="headline uppercase color-gray">Recipes</h1>
            <h3 className="sectionTitle margin-top-xsmall font-louisana color-gray">
                Liven up weeknight dinners inspired by Food Network Kitchen<sup>TM</sup> with crave-worthy recipes
            </h3>
            {/* <BodyCopy classes="color-gray margin-top-medium">
                            Our globally inspired salad dressings, cooking sauces, and meal kits make trying new and exciting flavors more convenient than ever. Take cues from the latest food trends to create your own beautiful, share-worthy dishes.
                        </BodyCopy>
                        <Benefits classes="justify-center margin-top-medium" /> */}
          </ImageOverlay>
          <div className="header-background">
            <img
              className="left"
              src={BuildImagePath(
                "recipes_left.png",
                "headers",
                imageSizeArray
              )}
              alt=""
            />
            <img
              className="right"
              src={BuildImagePath(
                "recipes_right.png",
                "headers",
                imageSizeArray
              )}
              alt=""
            />
          </div>
        </header>

        {this.state.recipeGroups}
      </div>
    );
  }
}

class RecipeGroup extends React.Component {
  constructor(props) {
    super(props);

    this.options = {
      numPerPage: 8,
      loadedAll: false
    };

    this.getRecipes = this.getRecipes.bind(this);
    this.showCards = this.showCards.bind(this);
    this.getAllRecipes = this.getAllRecipes.bind(this);

    this.state = {
      recipes: this.getRecipes(),
      scrollHandler: throttle(() => this.showCards(), 150)
    };
  }

  /*
        Get First page of recipes
        Shuffle recipes, return first ones and additional ones
    */
  getRecipes() {
    const shuffledRecipes = ShuffleArray(this.props.recipes);
    return {
      first: shuffledRecipes.slice(0, this.options.numPerPage),
      remaining: shuffledRecipes.slice(this.options.numPerPage)
    };
  }

  getAllRecipes(btn) {
    btn.target.parentNode.classList.add("button-hide");

    setTimeout(() => {
      this.setState({
        recipes: {
          first: this.state.recipes.first.concat(this.state.recipes.remaining),
          remaining: 0
        }
      });
    }, 300);
  }

  /*
        Build Card Components
    */
  buildRecipeCards() {
    let recipes = this.state.recipes.first;
    if (this.options.loadedAll === true) {
      recipes = recipes.concat(this.state.recipes.remaining);
    }
    return recipes.map(r => (
      <RecipeCard
        key={r.id}
        id={r.id}
        title={typeof r.shortname !== "undefined" ? r.shortname : r.name}
        description={r.description}
        image={r.image}
      />
    ));
  }

  /*
        Show Cards in group
    */
  showCards() {
    if (window.isMobile === true) {
      if (
        CheckVis(this.group, "eighthScreen", "top") &&
        this.group.classList.contains("visible") === false
      ) {
        this.group.classList.add("showFlipCards");
      }
    } else {
      if (
        CheckVis(this.group, "quarterScreen", "top") &&
        this.group.classList.contains("visible") === false
      ) {
        this.group.classList.add("showFlipCards");
      }
    }
  }

  //remove scroll listener when component unmounts
  componentWillUnmount() {
    window.removeEventListener("scroll", this.state.scrollHandler);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.state.scrollHandler);

    setTimeout(this.showCards, 500);
  }

  render() {
    let title = this.props.title.substr(0, this.props.title.length - 1);
    if (title.indexOf("dressing") > -1) {
      title = "Salad " + title;
    } else if (title.indexOf("sauce") > -1) {
      title = "Cooking " + title;
    }

    return (
      <Section
        id={this.props.title}
        classes="recipeGroup masterCard padding-y-xlarge padding-x-xlarge"
      >
        <SectionTitle color="red" classes="text-align-center">
          {title} Recipes
        </SectionTitle>
        <div
          className="grid fourColumn spacing-y-xlarge"
          ref={el => (this.group = el)}
        >
          {this.buildRecipeCards()}
          {this.state.recipes.remaining.length > 0 && (
            <div className="recipeGroup-actions text-align-center">
              <Button
                classes="secondary noBorder"
                color="gray"
                text={`Show All ${this.props.title.charAt(0).toUpperCase() +
                  this.props.title.slice(1)} Recipes`}
                onClick={this.getAllRecipes}
              />
            </div>
          )}
        </div>
      </Section>
    );
  }
}

class RecipeCard extends React.Component {
  render() {
    const max = 95;
    let truncatedDescription = this.props.description;
    if (truncatedDescription.length > max) {
      truncatedDescription = truncatedDescription.substr(0, max);
      truncatedDescription = truncatedDescription.substr(
        0,
        Math.min(
          truncatedDescription.length,
          truncatedDescription.lastIndexOf(" ")
        )
      );
      truncatedDescription = truncatedDescription + "...";
    }

    const imageSizeArray = [
      {
        w: 480,
        name: "small"
      },
      {
        w: 4000,
        name: "medium"
      }
    ];

    return (
      <Card
        type="product"
        category="Recipes"
        flip={true}
        title={this.props.title}
        desc={truncatedDescription}
        color="red"
        classes="flex-equalSize text-align-center"
        image={BuildImagePath(this.props.image, "recipes", imageSizeArray)}
        link={`/recipes/${this.props.id}`}
        button={{
          size: "secondary",
          color: "yellow",
          text: "Get Recipe"
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/allRecipes.js